"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSizes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("motion/react");
const close_svg_1 = __importDefault(require("../../icons/close.svg"));
const ButtonIcon_1 = __importDefault(require("../ButtonIcon"));
const Card_1 = __importDefault(require("../Card"));
const Spin_1 = __importDefault(require("../Spin"));
const Text_1 = __importStar(require("../Text"));
const Popover_1 = require("../../hoc/Popover");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var ModalSizes;
(function (ModalSizes) {
    ModalSizes["Small"] = "Small";
    ModalSizes["Medium"] = "Medium";
    ModalSizes["Large"] = "Large";
})(ModalSizes || (exports.ModalSizes = ModalSizes = {}));
const Modal = ({ children, isLoading, isScrollable, header, footer, size = ModalSizes.Medium, onClose, isGlobal, }) => {
    const isMotionReduced = (0, react_2.useReducedMotionConfig)();
    const Wrapper = (0, react_1.useMemo)(() => ({ children }) => {
        const className = (0, classnames_1.default)(styles_module_css_1.default.modal, styles_module_css_1.default[`modal${size}`]);
        if (isMotionReduced) {
            return (0, jsx_runtime_1.jsx)("div", { className: className, children: children });
        }
        return ((0, jsx_runtime_1.jsx)(react_2.motion.div, { initial: { opacity: 0, scale: 0 }, animate: { opacity: 1, scale: 1 }, exit: { opacity: 0, scale: 0 }, transition: { duration: 0.15 }, className: className, children: children }, "box"));
    }, [isMotionReduced]);
    return ((0, jsx_runtime_1.jsx)(Popover_1.PopoverRoot, { className: (0, classnames_1.default)(styles_module_css_1.default.modalWrapper, {
            [styles_module_css_1.default.modalWrapperGlobal]: isGlobal,
        }), children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)(Spin_1.default, { element: Card_1.default, spin: isLoading, lonely: true, scroll: isScrollable, "qa-element": "modal-content", header: header || onClose ? ((0, jsx_runtime_1.jsxs)("div", { className: styles_module_css_1.default.headerWithCloseBtn, "qa-element": "modal-title", children: [(0, jsx_runtime_1.jsx)(Text_1.default, { preset: Text_1.TextPresets.H3, children: header }), onClose && ((0, jsx_runtime_1.jsx)(ButtonIcon_1.default, { onClick: onClose, children: (0, jsx_runtime_1.jsx)(close_svg_1.default, { size: 12 }) }))] })) : undefined, footer: footer, children: children }) }) }));
};
exports.default = Modal;
